import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { LocaleContext, useTranslator } from '@/hooks/useTranslator';
import { DetailedBalance } from '@/types/bankInfo';
import { CurrencyCodeType } from '@/types/currency';
import { Locale } from '@/types/locale';
import { formatAmount } from '@/utility/formatAmount';

interface Props {
  readonly balance: DetailedBalance;
  readonly currency: CurrencyCodeType;
  readonly available?: boolean;
  readonly disabled?: boolean;
  readonly accountLabel?: string;
}

export const BalanceAccountDetailsItem: React.FC<Props> = (props: Props): React.ReactElement => {
  const { balance, currency, available = true, accountLabel } = props;

  const locale = React.useContext<Locale>(LocaleContext);
  const tr = useTranslator();

  const label = accountLabel ?? tr('CALIZA_ACCOUNT', currency);

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
      <Box>
        <Typography fontSize={16} lineHeight="24px" fontWeight={400}>
          {label}
        </Typography>
        <Typography fontSize={16} lineHeight="24px" fontWeight={400} color="custom.LightGray">
          {tr('BALANCE')}: {formatAmount(locale, balance.available, currency)}
        </Typography>
      </Box>
      {!available && (
        <Box>
          <Typography fontSize={14} fontWeight={400} lineHeight="20px" color="custom.LightGray">
            {tr('INSUFFICIENT_FUNDS')}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
